import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { exportToTablePDF } from "../../common/PdfFormat";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  addGoal,
  deleteGoal,
  editGoal,
  getGoal,
  getSingleGoal,
} from "../../redux/services/goalSlice";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import ConfirmationPage from "../../common/ConfirmationPage";
import GoalForm from "./GoalForm";

const Goal = () => {
  const dispatch = useDispatch();
  const getGoalData = useSelector((state) => state?.goal?.goalData);

  const getSingleGoalData = useSelector((state) => state?.goal?.singleGoalData);
  const [modelOpen, setModelOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [editId, setEditId] = useState();
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const initialValues = {
    name: "",
  };
  const validationSchema = Yup.object({
    name: Yup.string().required("Goal is required"),
  });
  const getAllGoal = useCallback(async () => {
    try {
      await dispatch(getGoal({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllGoal();
  }, [getAllGoal]);
  const onSubmit = async () => {
    setLoading(true);
    const payload = { ...values };
    if (editId) {
      payload.GoalId = editId;
    }
    try {
      let response;
      if (editId) {
        response = await dispatch(editGoal(payload));
      } else {
        response = await dispatch(addGoal(payload));
      }
      if (response?.payload?.status === 200) {
        toast.success(response?.payload?.message, {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setLoading(false);
        setModelOpen(false);
        resetForm();
        getAllGoal();
      }
    } catch (error) {}
    setModelOpen(false);
  };
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  const deleteGoalData = async () => {
    try {
      const response = await dispatch(deleteGoal(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllGoal();
    } catch (error) {}
  };
  useEffect(() => {
    if (editId) {
      const fetchSingleGoal = async () => {
        try {
          await dispatch(getSingleGoal(editId));
        } catch (error) {}
      };

      fetchSingleGoal();
    }
  }, [dispatch, editId]);

  useEffect(() => {
    if (getSingleGoalData) {
      setValues({
        name: getSingleGoalData.name,
      });
    }
  }, [getSingleGoalData, setValues]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      header: "Name",
      key: "name",
    },
  ];
  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setEditId(row._id);
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      { label: "S/N", key: "index", render: (_, __, index) => index + 1 },
      {
        label: "Name",
        key: "name",
        render: (_, row) => row?.name || "-",
      },
    ];
    const data = getGoalData?.goal_data || [];
    exportToTablePDF({
      tableName: "Goal Data",
      data,
      headersConfig,
      pdfName: "goal_data.pdf",
    });
  };
  return (
    <>
      <Table
        title="Goal"
        buttonTitle="Add Goal"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => setModelOpen(true)}
        columns={columns}
        data={getGoalData?.goal_data || []}
        actions={actions}
        pageCount={getGoalData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Goal"
          confirm={confirm}
          onDelete={deleteGoalData}
          onCancel={() => setConfirm(false)}
        />
      )}
      {modelOpen && (
        <GoalForm
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          onClose={() => {
            setModelOpen(false);
            resetForm();
            setEditId();
          }}
          values={values}
          handleChange={handleChange}
          editId={editId}
          handleBlur={handleBlur}
          errors={errors}
          touched={touched}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </>
  );
};

export default Goal;
